import React from 'react'
import { useTheme, TextField, MenuItem, Grid } from '@material-ui/core'
import { useAppContext } from 'contexts/AppContext'
import useCollection from 'hooks/useCollection'

const CohortSelector = () => {
  const theme = useTheme()

  const { userDocState, updateUserDoc } = useAppContext()
  const [cohortsState] = useCollection({
    path: 'cohorts',
    orderBy: { field: 'startDate', direction: 'desc' },
    filters:
      userDocState.doc.location[0].toUpperCase() === 'GLOBAL'
        ? []
        : [
            {
              field: 'location',
              operator: '==',
              value: userDocState.doc.location[0],
            },
          ],
  })

  const handleChange = async e => {
    if (e.target.value && updateUserDoc) {
      await updateUserDoc({ cohort: e.target.value })
      window.location.reload()
    }
  }

  if (!cohortsState.documents || cohortsState.documents.length === 0)
    return null

  return (
    <TextField
      select
      value={userDocState.doc.cohort}
      onChange={handleChange}
      fullWidth
      label="Cohort"
      variant="outlined"
      margin="dense"
    >
      {cohortsState.documents.map(doc => (
        <MenuItem key={doc.cohort} value={doc.cohort}>
          <Grid
            container
            wrap="nowrap"
            justify="space-between"
            alignItems="baseline"
            style={theme.typography.body2}
          >
            <Grid item>{doc.cohort}</Grid>
            <Grid item style={{ color: theme.palette.text.secondary }}>
              {doc.location}
            </Grid>
          </Grid>
        </MenuItem>
      ))}
    </TextField>
  )
}
export default CohortSelector
